import React, { useState, useMemo } from 'react';
import { UNITS_DICTIONARY, ACTIVITY_UNITS } from '../../config/unitsDictionary.js';

const OutlookKey = () => {
    return (
        <div className="outlook-key">
            <div style={{ marginTop: '1rem' }}>

                <div style={{ marginTop: '1rem' }}>

                    <p><strong>Units</strong></p>
                    <table style={{ borderCollapse: 'collapse', width: '100%', maxWidth: 500 }}>
                        <tbody>
                            {Object.values(UNITS_DICTIONARY).map(unit => (
                                <tr key={unit.shortLabel}>
                                    <td style={{ border: '1px solid #ccc', padding: '4px 8px' }}>{unit.shortLabel}</td>
                                    <td style={{ border: '1px solid #ccc', padding: '4px 8px' }}>{unit.label}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default OutlookKey;